
import React, { useState } from "react";
import moment from 'moment-jalaali'
import { Form, Button, Input, Space, Row, Col, Card, Table } from 'antd';
// import DatePicker from 'react-datepicker2';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import ValidatorHelper from "./helpers/ValidatorHelper";
import StringHelper from './helpers/StringHelper';
import strings from '../utils/strings';
import { SearchOutlined, ZoomInOutlined, PhoneOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import CrmCallReasonModal from "./user-business-report/crmReport/crmCallHistory/crmCallReasonModal";
import InsuranceDetails from "./shared/insuranceDetails/InsuranceDetails";
import { useGeneralStore } from "../store/slices/createGeneralSlice";
import { useReportsStore } from "../store/slices/createReportsSlice";

export default function CallHistory(params) {
    const reports = useReportsStore()
    const general = useGeneralStore();
    const loading = reports.crmAllCallHistory.loading;
    const data = reports.crmAllCallHistory.data;

    const [searchedColumn, setSearchedColumn] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [id, setID] = useState();
    const [requestId, setRequestId] = useState();
    let searchInput;
    const getColumnSearchProps = (dataIndex, title) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
        }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={(node) => {
                        searchInput = node;
                    }}
                    placeholder={`جستجو ${title}`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: "block" }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        جستجو
                    </Button>
                    <Button
                        onClick={() => handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        ریست
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : "",
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ""}
                />
            ) : (
                text
            ),
    });
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText("");
    };

    function convertToMoment(date) {
        return moment(date?.toDate()).format("YYYY-MM-DD");
    }

    function onFinish(values) {
        // const params = {
        //     FromDate: moment(values.fromDate).format('YYYY/MM/DD').replaceAll('/', '-'),
        //     ToDate: moment(values.toDate).format('YYYY/MM/DD').replaceAll('/', '-'),
        // }

        const params = {
            FromDate: convertToMoment(fromDate),
            ToDate: convertToMoment(toDate),
          };

        reports.getCrmAllCallHistory({ param: params });
    }

    const layout = {
        lg: 6,
        md: 12,
        xs: 24
    }

    const btnLayout = {
        lg: 6,
        md: 12,
        xs: 24
    }

    const columns = [
        Table.EXPAND_COLUMN,
        {
            title: 'مشاهده',
            dataIndex: "operation",
            width: 20,
            key: "operation",
            render: (_, record) =>
                data.length >= 1 && (
                    <Space size="middle">

                        <Button type='link' htmltype="submit"
                            onClick={() => {
                                setID(record.Id)
                                reports.getCrmCallHistoryReason(record.Id);
                                general.ToggleCrmCallReasonModal(true);
                            }}>
                            <PhoneOutlined />
                        </Button>

                    </Space>
                )
        },
        {
            title: "جزئیات بیمه نامه",
            dataIndex: "operation",
            key: "operation",
            width: 80,
            render: (_, record) =>
                data.length >= 1 && record.InsuranceRequestId != null && (
                    <Space size="middle">
                        <Button type='link' onClick={() => {
                            reports.getInsuranceDetailsInfo(record.InsuranceRequestId)
                            setRequestId(record.InsuranceRequestId);
                            general.ToggleInsuranceDetailsModal();
                        }
                        }><ZoomInOutlined /></Button>
                    </Space>
                ),
        },
        {
            title: 'کد تماس',
            dataIndex: 'Id',
            width: 60,
            render: (text) => StringHelper.getFarsiNum(text)
        },
        {
            title: "نام کاربری",
            dataIndex: "UserName",
            key: "UserName",
            width: 130,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.UserName ? (first = a.UserName) : (first = "");
                b.UserName ? (second = b.UserName) : (second = "");
                return first.localeCompare(second);
            },
            ...getColumnSearchProps("UserName", "نام کاربری"),
            render: text => text && strings.getFarsiNum(text),
        },
        {
            title: "نام کارشناس",
            dataIndex: "ExpertFullName",
            key: "ExpertFullName",
            width: 170,
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.ExpertFullName ? first = a.ExpertFullName : first = '';
                b.ExpertFullName ? second = b.ExpertFullName : second = '';
                return first.localeCompare(second)
            },
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>
        },
        {
            title: 'شماره همراه',
            dataIndex: "PhoneNumber",
            key: "PhoneNumber",
            width: 130,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.PhoneNumber ? (first = a.PhoneNumber) : (first = "");
                b.PhoneNumber ? (second = b.PhoneNumber) : (second = "");
                return first.localeCompare(second);
            },
            ...getColumnSearchProps("PhoneNumber", "شماره همراه"),
            render: text => text && strings.getFarsiNum(text),
        },

        {
            title: 'دلیل تماس',
            dataIndex: 'ReasonTitle',
            width: 180,
            key: 'ReasonTitle',
            render: text => strings.getFarsiNum(text),
        },
        {
            title: 'وضعیت تماس',
            dataIndex: 'CallStatusTitle',
            width: 110,
            key: 'CallStatusTitle',
        },
        {
            title: 'نوع تماس',
            dataIndex: 'CallTypeTitle',
            width: 110,
            key: 'CallTypeTitle',
            render: text => strings.getFarsiNum(text),
        },
        {
            title: 'تاریخ ثبت',
            dataIndex: 'CreationTime',
            key: 'CreationTime',
            width: 110,
            render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD  ساعت:  HH:mm'))
        },
        {
            title: "کد رهگیری",
            dataIndex: "RequestNumber",
            key: "RequestNumber",
            width: 150,
            sorter: (a, b) => a.RequestNumber.localeCompare(b.RequestNumber),
        },


    ];

    return (
        <Card className="my-call-histories">
            <Form
                className="sale-filter"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={onFinish}
                initialValues={{
                    fromDate: params.fromDate && moment(params.fromDate).subtract(1, 'months') || moment(),
                    toDate: params.toDate && moment(params.toDate) || moment()
                }}>

                <Row gutter={[8]}>

                    <Col {...layout}>
                        <Form.Item
                            name='fromDate'
                            label='از تاریخ'
                            rules={ValidatorHelper.required('تاریخ')}>
                            <DatePicker
                                value={fromDate}
                                onChange={setFromDate}
                                calendar={persian}
                                locale={persian_fa}
                                format="YYYY/MM/DD"
                                inputClass="datepicker-input"
                                calendarPosition="bottom-right"
                                portal
                                zIndex={1070}
                            />
                        </Form.Item>
                    </Col>
                    <Col {...layout}>
                        <Form.Item
                            name='toDate'
                            label='تا تاریخ'
                            rules={ValidatorHelper.required('تاریخ')}>
                            <DatePicker
                                value={toDate}
                                onChange={setToDate}
                                calendar={persian}
                                locale={persian_fa}
                                format="YYYY/MM/DD"
                                inputClass="datepicker-input"
                                calendarPosition="bottom-right"
                                portal
                                zIndex={1070}
                            />
                        </Form.Item>
                    </Col>
                    <Col {...btnLayout}>
                        <Form.Item label=" " colon={false}>
                            <button
                                disabled={loading} type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit">
                                جستجو&nbsp;&nbsp;&nbsp; <i className={loading ? "bx bx-loader bx-spin" : "fas fa-search"}></i>
                            </button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            <Table
                style={{ overflowX: 'scroll' }}
                className="custom-table"
                size="small"
                bordered
                columns={columns}
                loading={loading}
                rowKey="Id"
                scroll={true}
                dataSource={data}
                expandable={{
                    expandedRowRender: (record) => (
                        <p
                            style={{
                                margin: 0,
                                textAlign: "right"
                            }}
                        >
                            {record.Description}
                        </p>
                    ),
                }}
            />
            <CrmCallReasonModal callHistoryId={id} />
            <InsuranceDetails requestId={requestId} />
        </Card>
    )
}